import {Injectable, Injector} from '@angular/core';
import {RefreshTokenService} from '@app/app/shared/services/refresh-token.service';
import {HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import {environment} from '@app/environments/environment';

@Injectable()
export class RefreshTokenInterceptorService {

  constructor(public jwtHelper: JwtHelperService, private injector: Injector, private tokenService: RefreshTokenService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = this.injector.get(AuthenticationService);
    const token: any = auth.getToken();
    const tokenIsExpired = token ? this.jwtHelper.isTokenExpired(token) : true;
    if (auth.isAuthenticated() && tokenIsExpired && !this.tokenService.processing && request.url !== environment.refreshTokenUrl) {
      this.tokenService.processing = true;
      return auth.refreshToken().flatMap(
        (res: any) => {
          auth.saveToken(res);
          this.tokenService.publish(res);
          this.tokenService.processing = false;
          return next.handle(request);
        }
      ).catch(() => {
        this.tokenService.publish({});
        this.tokenService.processing = false;
        auth.logOut();
        return next.handle(request);
      });
    } else if (request.url === environment.refreshTokenUrl) {
      return next.handle(request);
    }

    if (this.tokenService.processing) {
      return this.tokenService.storage.flatMap(
        () => {
          return next.handle(request);
        }
      );
    } else {
      return next.handle(request);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/refresh-token-interceptor.service.ts